import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { ErrorFallback } from '@/components/ErrorFallback';

import { useSidebar } from '../../hooks/use-sidebar';
import Header from './Header';
import LateralMenu from './LateralMenu';
import { Container } from './styles';

const PrivatePage: React.FC = ({ children }) => {
  const { isChanging, isMini } = useSidebar();

  let classCSS = '';
  if (isChanging) {
    classCSS = isMini ? 'sidebar-mini' : 'sidebar-large';
  }

  return (
    <div className="h-[100vh] overflow-hidden">
      <LateralMenu />
      <Container className={classCSS} sidebarIsMini={isMini}>
        <Header />

        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            // reset the state of your app so the error doesn't happen again
          }}
        >
          <div className="h-full max-h-full w-full overflow-y-auto">{children}</div>
        </ErrorBoundary>
      </Container>
    </div>
  );
};

export default PrivatePage;
